<template>
  <div class="richiesta-contatti">

    <overlay-back/>

    <div class="default-container-smaller">
      <header>
        <h1>{{ pageApiData.title }}</h1>
      </header>
      <form @submit.prevent="$_sendForm">
        <div class="inputs-container inputs-container-double">
          <!-- name -->
          <div class="form-field form-field--text">
            <span
              class="input input--juro"
              :class="{ 'input--filled': name.trim().length > 0 }">
              <input
                v-model="name"
                v-validate="'required'"
                name="name"
                class="input__field input__field--juro"
                type="text" />

              <label class="input__label input__label--juro" for="input">
                <span class="input__label-content input__label-content--juro">{{ $t('contactsForm.labelName') }}</span>
              </label>
            </span>
            <span class="form-field__error">{{ errors.first('name') }}</span>
          </div>
          <!-- surname -->
          <div class="form-field form-field--text">
            <span
              class="input input--juro"
              :class="{ 'input--filled': surname.trim().length > 0 }">
              <input
                v-model="surname"
                v-validate="'required'"
                name="surname"
                class="input__field input__field--juro"
                type="text"/>

              <label class="input__label input__label--juro" for="input">
                <span class="input__label-content input__label-content--juro">{{ $t('contactsForm.labelSurname') }}</span>
              </label>
            </span>
            <span class="form-field__error">{{ errors.first('surname') }}</span>
          </div>
        </div>

        <div class="inputs-container inputs-container-double">
          <!-- email -->
          <div class="form-field form-field--text">
            <span
              class="input input--juro"
              :class="{ 'input--filled': email.trim().length > 0 }">
              <input
                v-model="email"
                v-validate="'required|email'"
                name="email"
                class="input__field input__field--juro"
                type="text" />

              <label class="input__label input__label--juro" for="input">
                <span class="input__label-content input__label-content--juro">{{ $t('contactsForm.labelEmail') }}</span>
              </label>
            </span>
            <span class="form-field__error">{{ errors.first('email') }}</span>

          </div>
          <!-- company -->
          <div class="form-field form-field--text">
            <span
              class="input input--juro"
              :class="{ 'input--filled': company.trim().length > 0 }">
              <input
                v-model="company"
                class="input__field input__field--juro"
                type="text"/>

              <label class="input__label input__label--juro" for="input">
                <span class="input__label-content input__label-content--juro">{{ $t('contactsForm.labelCompany') }}</span>
              </label>
            </span>
          </div>
        </div>

        <div class="inputs-container inputs-container-double">
          <!-- telephone -->
          <div class="form-field form-field--text">
            <span
              class="input input--juro"
              :class="{ 'input--filled': telephone.trim().length > 0 }">
              <input
                v-model="telephone"
                class="input__field input__field--juro"
                type="text" />

              <label class="input__label input__label--juro" for="input">
                <span class="input__label-content input__label-content--juro">{{ $t('contactsForm.labelTelephone') }}</span>
              </label>
            </span>
          </div>
          <!-- city -->
          <div class="form-field form-field--text">
            <span
              class="input input--juro"
              :class="{ 'input--filled': city.trim().length > 0 }">
              <input
                v-model="city"
                class="input__field input__field--juro"
                type="text"/>

              <label class="input__label input__label--juro" for="input">
                <span class="input__label-content input__label-content--juro">{{ $t('contactsForm.labelCity') }}</span>
              </label>
            </span>
          </div>
        </div>

        <div class="inputs-container">
          <!-- message -->
          <div class="form-field form-field--text">
            <span
              class="input input--juro"
              :class="{ 'input--filled': message.trim().length > 0 }">
              <input
                v-model="message"
                v-validate="'required'"
                name="message"
                class="input__field input__field--juro"
                type="text" />

              <label class="input__label input__label--juro" for="input">
                <span class="input__label-content input__label-content--juro">{{ $t('contactsForm.labelMessage') }}</span>
              </label>
            </span>
            <span class="form-field__error">{{ errors.first('message') }}</span>
          </div>
        </div>

        <div class="area-checks">
          <p style="margin-bottom:1rem;">{{ $t('contactsForm.labelEndCheck') }}</p>
          <!-- check privacy -->
          <p class="checks">
            <input
              v-model="privacy"
              v-validate="'required'"
              name="privacy"
              id="privacy"
              value="acconsento"
              type="checkbox">

            <label for="privacy" class="label_check">
              <span class="before"></span>
              <span class="text_check" v-html="$t('contactsForm.labelAllowed')"></span>
            </label>
            <span class="form-field__error">{{ errors.first('privacy') }}</span>
          </p>
          <!-- check newletter -->
          <p class="checks">
            <input
              v-model="newsletter"
              name="newsletter"
              id="newsletter"
              value="acconsento"
              type="checkbox">

            <label for="newsletter" class="label_check">
              <span class="before"></span>
              <span class="text_check" v-html="$t('contactsForm.labelNewsletter')"></span>
            </label>
          </p>
        </div>
        <div style="text-align:right; padding: 4rem 0 5rem;">
          <button class="submit-button">
            {{ $t('contactsForm.labelSubmit') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { load } from 'recaptcha-v3'
import lang from '@/views/mixins/lang'
import dataLoad from '@/views/mixins/dataLoad'
import OverlayBack from '@/components/OverlayBack'

export default {
  mixins: [ lang, dataLoad ],
  components: {
    OverlayBack
  },
  data: () => ({
    email: '',
    name: '',
    surname: '',
    company: '',
    telephone: '',
    city: '',
    message: '',
    privacy: false,
    newsletter: false,
    sendmore: true
  }),
  methods: {
    $_validateBeforeSubmit () {
      return this.$validator.validateAll()
    },
    async $_sendForm () {
      const validated = await this.$_validateBeforeSubmit()
      console.log('this.sendmore', this.sendmore)
      if (validated && this.sendmore) {
        // load recaptcha token
        this.sendmore = false
        const recaptcha = await load('6LfsM9sqAAAAAJnEExmfTHSwhJQfn2YXA1Mvcxw8')
        this.token = await recaptcha.execute('contacts')
        const apiId = this.lang === 'it' ? 'd2c712d7-f325-4437-8a85-0598f5383175' : '7ffde5ef-0c91-48ae-b9f5-8fc762ce56e8'
        // console.log('token', this.token)
        if (typeof this.token !== 'undefined') {
          try {
            const formData = new FormData()
            formData.append('captcha', this.token)
            formData.append('api_id', apiId)
            formData.append('name', this.name)
            formData.append('surname', this.surname)
            formData.append('company', this.company)
            formData.append('telephone', this.telephone)
            formData.append('city', this.city)
            formData.append('email', this.email)
            formData.append('newsletter', this.newsletter)
            formData.append('message', this.message)
            const sendMail = await axios.post('https://postin.quammbase.it/emails/', formData)

            if (sendMail.status === 200) {
              window.dataLayer.push({
                event: `richiesta-contatti-${this.lang}`
              })
              this.$router.push({ name: `${this.lang}-success` })
              return true
            }
            this.$router.push({ name: `${this.lang}-failure` })
            return false
          } catch (err) {
            console.log('sendMail', err)
            this.$router.push({ name: `${this.lang}-failure` })
            return false
          }
        }
      }
      // const reply = await axios.post(process.env.VUE_APP_FORM_ENDPOINT + '/save', this.$data)
      // console.log(reply)
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/mixins/breakpoints";
  @import "../assets/mixins/typo";

  .richiesta-contatti{
    position: fixed;
    top: 0;
    z-index: 175;
    height: 100vh;
    width: 100%;
    background-color: #1d1d1b;
    overflow: auto;
  }
  .richiesta-contatti header{
    padding: 6rem 0 5rem;

    h1{
      margin-bottom: 3rem;
      margin-top: 4rem;
      @media #{$large_mq} {
        margin-top: 13rem;
        margin-bottom: 4rem;
      }
      @include hero-title(#EFEFF1);
      br{
        display: none;
        @media #{$large_mq} {
          display: none;
        }
      }
    }
  }
.inputs-container{
  margin: 0;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;

  @media #{$medium_mq} {
    flex-direction: row;
    margin: 2rem 0;
  }
}
.inputs-container .form-field{
  width: 100%;
  margin: 0 0 .5rem;
}
.inputs-container.inputs-container-double{
  @media #{$medium_mq} {
    .form-field{
      width: 50%;
    }
    .form-field:nth-child(odd){
      margin-right: 2.5rem;
    }
    .form-field:nth-child(even){
      margin-left: 2.5rem;
    }
  }
}

/* inputs */

*, *:after, *:before {
  box-sizing: border-box;
}

.clearfix:before, .clearfix:after {
  content: "";
  display: table;
}

.clearfix:after {
  clear: both;
}

.input {
  position: relative;
  z-index: 1;
  display: inline-block;
  margin: .8rem 0 .4rem;
  width: 100%;
  vertical-align: top;
  padding-top: 12px;
}
.input__field {
  position: relative;
  display: block;
  float: right;
  padding: 0.8em;
  width: 60%;
  border: none;
  border-radius: 0;
  background: #FFF;
  color: #EFEFF1;
  -webkit-appearance: none;
}
.input__field:focus {
  outline: none;
}
.input__field--juro {
  position: absolute;
  z-index: 100;
  padding: 1.6rem 0 0;
  width: 100%;
  background: transparent;
  color: #EFEFF1;
  font-size: 20px;
  line-height: 1.2;
  font-weight: 300;
}
.input__label {
  display: inline-block;
  color: #FFFFFF;
  font-size: 70.25%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.input__label-content {
  position: relative;
  display: block;
  padding: 1.6em 0;
  width: 100%;
}
.input__label-content--juro {
  font-size: 20px; line-height: 1;
  color: #9B9B9B;
  padding: 1.6rem 0;
  -webkit-transform-origin: 0% 50%;
          transform-origin: 0% 50%;
  transition: color 0.3s, -webkit-transform 0.3s;
  transition: transform 0.3s, color 0.3s;
  transition: transform 0.3s, color 0.3s, -webkit-transform 0.3s;
  text-rendering: geometricPrecision;
}
.input__label--juro {
  padding: 0;
  width: 100%;
  height: 100%;
  text-align: left;
  border-bottom: 1px solid #9B9B9B !important;
}
.input__label--juro::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: border-width 0.3s, border-color 0.3s;
}
.input--juro {
  overflow: hidden;
}

.input__field--juro:focus + .input__label--juro::before,
.input--filled .input__label--juro::before {
  border-width: 8px;
  border-top-width: 2em;
  border-bottom: 1px solid #FFF;
}

.input__field--juro:focus + .input__label--juro .input__label-content--juro,
.input--filled .input__label--juro .input__label-content--juro {
  color: #9B9B9B;
  -webkit-transform: translate3d(0, -1.75em, 0) scale3d(0.7, 0.7, 1) translateZ(1px);
  transform: translate3d(0, -1.75em, 0) scale3d(0.7, 0.7, 1) translateZ(1px);
  text-transform: uppercase;
}

// CHECKS

.checks {
    text-align: left;
    position: relative;
}

.area-checks{
  margin-top: 6rem;
  p{
    font-size: 14px;
    line-height: 1.6;
    font-family: 'Roboto', sans-serif;
    font-weight: 300;
    color: #9B9B9B;
    margin: 0;

    @media #{$xlarge_mq} {
      font-size: 1.6rem;
    }
  }
  a{
   color: #FFFFFF;
   text-decoration: underline;
  }

  p.checks{
    padding: 5px 0 0;
    line-height: 1.2;
  }
}

.checks-marginUp{
  margin: 60px 0;
}

input[type="checkbox"]{
  width: 20px;
  opacity: 0;
  position: absolute;
  top: 5px;
}

.text_check {
  margin-left: 35px;
  font-size: 14px;
  display: block;
  line-height: 1.4;
}

.label_check .before {
  content: "";
  border: 1px solid #4F4F4E;
  display: inline-block;
  width: 16px;
  height: 16px;
  padding: 2px;
  text-align: center;
  position: absolute;
  top: 3px;
  left: 0;
  background-color: transparent;
  background-position: center center;
  background-repeat: no-repeat;
}

.area-checks .label_check .before {
  content: "";
  background-color: transparent;
}

input:checked + .label_check .before {
  background-image: url("data:image/svg+xml,%3Csvg width='16px' height='21px' viewBox='0 0 16 21' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Desktop-HD-1920-Copy' transform='translate%28-681.000000, -1354.000000%29' stroke='%23FFFFFF' stroke-width='3'%3E%3Cpolyline id='Path-2-Copy' points='683 1363.7342 688.240929 1371.26784 695 1355'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 10px 9px;
}

.submit-button {
  @include link-triangle-effect-custom(#EFEFF1);
  border: 0;
  background-color: #679196;
  border-radius: 0;
  margin: 3rem 0;
  padding: 26px 50px 26px 30px;
  -webkit-appearance: none;
  cursor: pointer;
  &::after{
    top: 29px;
    right: 27px;
  }
  outline-style: none;
}

.submit-button::-moz-focus-inner, .submit-button:focus {
  border: none;
  outline: none;
}

.form-field__error{
  font-size: .65rem;
  line-height: 1;
  color: #d0675a;
}

.checks .form-field__error{
  padding-left: 35px;
}

.form-success, .form-failure{
  padding-top: 3rem;
  @media #{$medium_mq} {
    text-align: center;
  }

  p{
    font-size: 2.2rem;
    line-height: 1.3;
    color: #EFEFF1;
  }

  a, .form-failure_span{
    font-size: 1.6rem;
    line-height: 1.3;
    color: #EFEFF1;
  }
}

/* TRANSITIONS */

.fade-leave-active {
  transition: opacity .5s;
  transition-delay: 0s;
}
.fade-enter-active{
  transition-delay: .7s;
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.richiesta-contatti .hamburger-menu, .richiesta-contatti .hamburger-menu:after, .richiesta-contatti .hamburger-menu:before, .dove-siamo .hamburger-menu, .dove-siamo .hamburger-menu:after, .dove-siamo .hamburger-menu:before{
  height: 1px;
  width: 30px;
}
input:-webkit-autofill, textarea:-webkit-autofill, select:-webkit-autofill {
  background-color: transparent !important;
  color: #EFEFF1 !important;
}
.form-failure button{
  margin: 2rem 2rem 0 0;
}
.grecaptcha-badge{
  display: none;
}
</style>
